import { render, staticRenderFns } from "./ReferralNav.vue?vue&type=template&id=5a4ca514&"
import script from "./ReferralNav.vue?vue&type=script&lang=js&"
export * from "./ReferralNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports